<template>
  <div class="navBar">
    <div class="changeLanguage">
      <span class="tips" @click="changeLanguage()">
        {{ $t("language") }}
      </span>
    </div>
    <div class="container">
      <img class="icon" src="@img/logo.png" />
      <ul class="nav">
        <li
          :class="activeIndex == index ? 'current' : ''"
          v-for="(item, index) in nav"
          :key="index"
          @click="clickNav(item, index)"
        >
          <span>{{ $t(`navBar.nav.${item.name}`) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { handleLocalStorage } from "../../utils/index";
export default {
  data() {
    return {
      activeIndex: 0,
      nav: [
        {
          name: "home",
          url: "/",
        },
        {
          name: "tools",
          url: "/tools",
        },
        {
          name: "cases",
          url: "/cases",
        },
        {
          name: "cooperate",
          url: "/cooperate",
        },
        {
          name: "talents",
          url: "/talents",
        },
        {
          name: "about",
          url: "/about",
        },
        {
          name: "login",
          url: "http://app.dados.com.cn/",
        },
      ],
    };
  },
  created() {
    this.activeIndex = [
      "/",
      "/tools",
      "/cases",
      "/cooperate",
      "/talents",
      "/about",
      "http://app.dados.com.cn/",
    ].indexOf(this.$route.path);
  },
  methods: {
    clickNav(item, index) {
      if (item.url.startsWith("http")) {
        location.href = item.url;
      } else {
        this.activeIndex = index;
        document.getElementsByTagName("html")[0].scrollTop = 0;
        location.href = location.origin + "/#" + item.url;
        location.reload(); // 重新触发wow动画
      }
    },
    changeLanguage() {
      this.lang = this.lang === "en" ? "zh" : "en";
      let type = this.lang;
      localStorage.setItem("dados_env", type);
      this.$i18n.locale = type;
      // console.log("xxxx");
      // if (this.lang === "zh") {
      //   this.lang = "en";
      //   this.$i18n.locale = this.lang; //关键语句
      //   handleLocalStorage("set", "dados_env", "en");
      // } else {
      //   this.lang = "zh";
      //   this.$i18n.locale = this.lang; //关键语句
      //   handleLocalStorage("set", "dados_env", "zh");
      // }
    },
  },
  mounted() {
    let env = handleLocalStorage("get", "dados_env");
    if (!env) {
      handleLocalStorage("set", "dados_env", "zh");
    } else {
      this.lang = env;
    }
    // if (!this.lang) {
    //   this.lang = "zh";
    // }
  },
};
</script>

<style lang="less" scoped>
.navBar {
  width: 100%;
  height: 112px;
  background: #000e20;
  opacity: 0.75;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 990;
  .changeLanguage {
    position: relative;
    z-index: 991;
    margin: 0 auto;
    width: 1280px;
    height: 20%;
    .tips {
      position: absolute;
      top: 15px;
      right: 24px;
      width: 100px;
      height: 20px;
      color: #fff;
      font-size: 18px;
      text-align: right;
      cursor: pointer;
      &:hover {
        color: #5186ff;
      }
    }
  }
  .container {
    width: 1280px;
    height: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .icon {
      width: 200px;
      height: auto;
      margin-right: auto;
      margin-bottom: 20px;
    }
    ul {
      height: 100%;
      li {
        display: inline-block;
        height: 100%;
        padding: 0 24px;
        font-size: 20px;
        line-height: 112px;
        font-weight: bold;
        color: #ffffff;
        &.current {
          color: #5186ff;
        }
        &:hover {
          color: #5186ff;
          cursor: pointer;
        }
        &:first-child {
          width: 50px;
        }
      }
    }
  }
}

.nav > li,
.nav > li.current {
  position: relative;
}

.nav > li > span:before {
  content: "";
  display: inline-block;
  width: 0;
  height: 0px;
  background: #5186ff;
  position: absolute;
  top: 0px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: width 0.4s;
}
.nav > li.current > span:before {
  width: 100%;
}
.nav > li:hover > span:before {
  width: 100%;
}
.nav > li:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue